let elements = {
  mainImage: {
    imagePath: 'games/page997_game1/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  type: 'findImage',
  withoutCheck: false,
  columns: 3,
  rows: 3,
  audio: {
    negative: 'games/page997_game1/audio/f.mp3',
    positive: 'games/page997_game1/audio/t.mp3',
  },
  imageToFind: {
    src: 'games/page997_game1/img/find.png',
    width: 1460,
    height: 861,
    pos: {
      x: 210,
      y: 130,
    },
  },
  curtainImages: [
    {
      src: 'games/page997_game1/img/1.png',
      index: 0,
    },
    {
      src: 'games/page997_game1/img/2.png',
      index: 1,
    },
    {
      src: 'games/page997_game1/img/3.png',
      index: 2,
    },
    {
      src: 'games/page997_game1/img/4.png',
      index: 3,
    },
    {
      src: 'games/page997_game1/img/5.png',
      index: 4,
    },
    {
      src: 'games/page997_game1/img/6.png',
      index: 5,
    },
    {
      src: 'games/page997_game1/img/7.png',
      index: 6,
    },
    {
      src: 'games/page997_game1/img/8.png',
      index: 7,
    },
    {
      src: 'games/page997_game1/img/9.png',
      index: 8,
    },
  ],
  curtainImage: {
    src: 'games/page997_game1/img/des.png',
  },
};

export default elements;
